<template>
  <div>
    <section class="login-container boxed-login" @keyup.enter="signin">
      <div class="container">
        <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4">
          <div class="login-form-container">
            <div class="j-forms" id="forms-login" novalidate="novalidate">
              <div class="login-form-header">
                <div class="logo">
                  <img class="logo-pic" src="../../assets/img/logo3.png" alt="logo">
                </div>
              </div>
              <h3>邀請連結驗證中....請稍等</h3>
            </div>
            <hr>
            <div class="pointer">
                <a class="gary" @click="goToDashboard()">返回首頁</a>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Start Here -->
      <footer class="login-page-footer">
      </footer>
      <!--Footer End Here -->
    </section>
    
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'accept_invitation',
  components: { Simplert },
  data() {
    return {
      email: '',
      resend_email: '',
      response: '',
      resendValidateMailModal: false,
      forgotPasswordModal: false,
      email: '',
      invite_token: '',
      password: '',
      re_password: '',
      refs: this.$refs
    }
  },
  beforeCreate: function() {
    document.body.className = 'accept_invitation';
  },
  created() {
    this.checkParams();
  },
  methods: {
    checkParams(){
      this.email = this.$route.query.email
      this.invite_token = this.$route.query.invite_token
      console.log(this.email !=''&& this.invite_token!='')
      if(this.email ===undefined || this.invite_token === undefined){
        this.$router.push('/login');
      }

      const vm = this;
      this.axios.post('/users/accept_invitation', {
        user: {
          email: this.email,
          invite_token: this.invite_token,
        }
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var company = response['data']['data']
          var obj = {
            isShown: true,
            title: '加入『'+company["company"]["name"]+'』成功',
            message: '',
            type: 'success',
            customCloseBtnText: '回到首頁',
            onClose: vm.goToDashboard,
            disableOverlayClick: true
          }
        } else {
          var obj = {
            isShown: true,
            title: '此連結已失效',
            message: '請你的邀請者重新邀請你加入，並且在點擊一次邀請按鈕。若持續出現此問題，煩請回報 service@flowneat.com',
            type: 'error',
            customCloseBtnText: '返回',
            onClose: vm.goToDashboard,
            disableOverlayClick: true
          }
        }
        setTimeout(function(){ 
          vm.refs.simplert.openSimplert(obj);
        }, 1500)
      })
      .catch(function(error) {
        console.log('error:', error)
      });

    },
    // if user have already login, then deny him go login page
    goToDashboard(){
      this.$router.push('/dashboard');
    }
  }
}
</script>


// WEBPACK FOOTER //
// AcceptInvitation.vue?318ad00c